/**
 * Apply a daily reward's effects to a Player at game start.
 *
 * Cosmetic only — the reward never changes physics, collision, or scoring.
 */

import type { Player } from './player';
import type { StorageManager, ActiveReward } from '@/storage/save-data';
import { hexToColor } from '@/types';
import { getActiveReward as activeRewardFromState } from './daily-rewards';

export function getActiveReward(
  storage: StorageManager,
  nowMs: number = Date.now(),
): ActiveReward | null {
  return activeRewardFromState(storage.getDailyReward(), nowMs);
}

/**
 * Stamp the reward (or its absence) onto a Player. `baseColor` is the level's
 * declared color; it's used as the player color unless a color reward overrides.
 */
export function applyRewardToPlayer(
  player: Player,
  reward: ActiveReward | null,
  baseColor: string,
): void {
  // Reset all reward-driven fields to their defaults first.
  player.shape = 'equilateral';
  player.hasGooglyEyes = false;
  player.rainbowTrail = false;
  player.color = hexToColor(baseColor);

  if (!reward) return;

  switch (reward.kind) {
    case 'color':
      player.color = hexToColor(reward.color);
      return;
    case 'shape':
      player.shape = reward.shape;
      return;
    case 'googly-eyes':
      player.hasGooglyEyes = true;
      return;
    case 'rainbow-trail':
      player.rainbowTrail = true;
      return;
  }
}
